import type { FlagInfo } from './types';

// const isNotStableBuild = BUILD_CONFIG.appBuildType !== 'stable';
const isDesktopEnvironment = BUILD_CONFIG.isElectron;
const isCanaryBuild = BUILD_CONFIG.appBuildType === 'canary';
const isMobile = BUILD_CONFIG.isMobileEdition;

export const HIVE_FLAGS = {
  enable_ai: {
    category: 'hive',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-ai.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-ai.description',
    hide: true,
    configurable: true,
    defaultState: true,
  },
  enable_ai_network_search: {
    category: 'hive',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-ai-network-search.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-ai-network-search.description',
    hide: true,
    configurable: false,
    defaultState: true,
  },
  enable_block_query: {
    category: 'blocksuite',
    bsFlag: 'enable_block_query',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-block-query.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-block-query.description',
    configurable: isCanaryBuild,
  },
  enable_edgeless_text: {
    category: 'blocksuite',
    bsFlag: 'enable_edgeless_text',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-edgeless-text.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-edgeless-text.description',
    configurable: false,
    defaultState: true,
  },
  enable_color_picker: {
    category: 'blocksuite',
    bsFlag: 'enable_color_picker',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-color-picker.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-color-picker.description',
    configurable: false,
    defaultState: true,
  },
  enable_ai_chat_block: {
    category: 'blocksuite',
    bsFlag: 'enable_ai_chat_block',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-ai-chat-block.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-ai-chat-block.description',
    configurable: false,
    defaultState: true,
  },
  enable_ai_onboarding: {
    category: 'blocksuite',
    bsFlag: 'enable_ai_onboarding',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-ai-onboarding.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-ai-onboarding.description',
    configurable: false,
    defaultState: true,
  },
  enable_mind_map_import: {
    category: 'blocksuite',
    bsFlag: 'enable_mind_map_import',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-mind-map-import.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-mind-map-import.description',
    configurable: false,
    defaultState: true,
  },
  enable_block_meta: {
    category: 'blocksuite',
    bsFlag: 'enable_block_meta',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-block-meta.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-block-meta.description',
    configurable: isCanaryBuild,
    defaultState: true,
  },
  enable_callout: {
    category: 'blocksuite',
    bsFlag: 'enable_callout',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-callout.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-callout.description',
    configurable: isCanaryBuild,
    defaultState: isCanaryBuild,
  },

  enable_emoji_folder_icon: {
    category: 'hive',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-emoji-folder-icon.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-emoji-folder-icon.description',

    feedbackType: 'discord',
    feedbackLink:
      'https://discord.com/channels/959027316334407691/1280014319865696351/1280014319865696351',
    configurable: true,
    defaultState: true,
  },
  enable_emoji_doc_icon: {
    category: 'hive',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-emoji-doc-icon.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-emoji-doc-icon.description',
    feedbackType: 'discord',
    feedbackLink:
      'https://discord.com/channels/959027316334407691/1280014319865696351',
    configurable: true,
    defaultState: true,
  },
  enable_editor_settings: {
    category: 'hive',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-editor-settings.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-editor-settings.description',
    configurable: false,
    defaultState: true,
  },
  enable_theme_editor: {
    category: 'hive',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-theme-editor.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-theme-editor.description',
    configurable: isCanaryBuild && !isMobile,
    defaultState: isCanaryBuild,
  },
  enable_local_workspace: {
    category: 'hive',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-local-workspace.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-local-workspace.description',
    configurable: false,
    defaultState: false,
    hide: true,
  },
  enable_advanced_block_visibility: {
    category: 'blocksuite',
    bsFlag: 'enable_advanced_block_visibility',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-advanced-block-visibility.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-advanced-block-visibility.description',
    configurable: true,
    defaultState: false,
  },
  enable_mobile_keyboard_toolbar: {
    category: 'blocksuite',
    bsFlag: 'enable_mobile_keyboard_toolbar',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-mobile-keyboard-toolbar.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-mobile-keyboard-toolbar.description',
    configurable: false,
    defaultState: isMobile,
  },
  enable_mobile_linked_doc_menu: {
    category: 'blocksuite',
    bsFlag: 'enable_mobile_linked_doc_menu',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-mobile-linked-doc-menu.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-mobile-linked-doc-menu.description',
    configurable: false,
    defaultState: isMobile,
  },
  enable_multiple_cloud_servers: {
    category: 'hive',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-multiple-cloud-servers.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-multiple-cloud-servers.description',
    configurable: false,
    defaultState: isDesktopEnvironment || BUILD_CONFIG.isIOS,
  },
  enable_mobile_edgeless_editing: {
    category: 'hive',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-mobile-edgeless-editing.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-mobile-edgeless-editing.description',
    configurable: isMobile,
    defaultState: false,
  },
  enable_pdf_embed_preview: {
    category: 'hive',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-pdf-embed-preview.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-pdf-embed-preview.description',
    configurable: !isMobile,
    defaultState: false,
  },
  enable_editor_rtl: {
    category: 'hive',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-editor-rtl.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-editor-rtl.description',
    configurable: isCanaryBuild,
    defaultState: false,
  },
  enable_mobile_ai_button: {
    category: 'hive',
    displayName: 'Enable AI Button',
    description: 'Enable AI Button on mobile',
    configurable: BUILD_CONFIG.isMobileEdition,
    defaultState: false,
  },
  enable_turbo_renderer: {
    category: 'hive',
    displayName: 'Enable Turbo Renderer',
    description: 'Enable experimental edgeless turbo renderer',
    configurable: isCanaryBuild,
    defaultState: false,
  },
  enable_edgeless_scribbled_style: {
    category: 'blocksuite',
    bsFlag: 'enable_edgeless_scribbled_style',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-edgeless-scribbled-style.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-edgeless-scribbled-style.description',
    configurable: isCanaryBuild,
    defaultState: false,
  },
  enable_meetings: {
    category: 'hive',
    displayName:
      'com.hive.settings.workspace.experimental-features.enable-meetings.name',
    description:
      'com.hive.settings.workspace.experimental-features.enable-meetings.description',
    configurable: !isMobile && environment.isMacOs && BUILD_CONFIG.isElectron,
    feedbackType: 'discord',
    feedbackLink:
      'https://discord.com/channels/959027316334407691/1358384103925350542',
    defaultState: false,
  },
  // TODO(@L-Sun): remove this flag after the feature is released
  enable_embed_doc_with_alias: {
    category: 'blocksuite',
    bsFlag: 'enable_embed_doc_with_alias',
    displayName: 'Embed doc with alias',
    description: 'Embed doc with alias',
    configurable: isCanaryBuild,
    defaultState: isCanaryBuild,
  },
} satisfies { [key in string]: FlagInfo };

// oxlint-disable-next-line no-redeclare
export type HIVE_FLAGS = typeof HIVE_FLAGS;
